import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { UserMe } from "@serasa/core/modules/recertification/interfaces/user-me.interface";
import { SiteSection } from "@serasa/shared/enums/site-section.enum";
import { AnalyticsService } from "@serasa/shared/services/analytics.service";
import { Utils } from "@serasa/shared/utils/utils";
import { Observable, Subscription, tap } from "rxjs";

import { environment } from "../../../../environments/environment";
import { RecertificationService } from "../../../core/modules/recertification/services/recertification.service";
import { CompanyInfo } from "../../../core/modules/users/interfaces/company-info.interface";
import { closeSideNav } from "../../../core/modules/users/state/actions/user.actions";
import {
  selectCompanyInfo,
  selectUserMeInfo,
} from "../../../core/modules/users/state/selectors/user.selectors";

import * as UserActions from "../../../core/modules/users/state/actions/user.actions";

export enum managerOpt {
  YES = "Sim, sou {{profile}} desse contrato.",
  NO = "Não, não sou mais {{profile}} desse contrato.",
}

@Component({
    selector: "pl-recertification-confirmation",
    templateUrl: "./recertification-confirmation.component.html",
    styleUrls: ["./recertification-confirmation.component.scss"],
    standalone: false
})
export class RecertificationConfirmationComponent implements OnInit, OnDestroy {
  public $interval?: number;
  public $sub?: Subscription;
  public companyInfo?: CompanyInfo;
  public hasError = false;
  public urlToRedirect = "";
  public managerOpt = managerOpt;
  public nextRecertificationDate?: string;
  public selectedItem!: string;
  public success = false;
  public userMeInfo$!: Observable<UserMe | null | undefined>;

  public options: string[] = [];
  public pageName?: string;
  public userProfile = "";

  @Input() mode = "";
  @Output() recerticationIsSuccess = new EventEmitter<boolean>();

  constructor(
    private readonly _recertificationService: RecertificationService,
    private readonly _analyticsService: AnalyticsService,
    private readonly store: Store
  ) {
    this.store
      .select(selectCompanyInfo)
      .pipe(
        tap((info) => {
          this.companyInfo = info;
        }),
      )
      .subscribe();
  }

  ngOnInit() {
    this.pageName = `${SiteSection.REVISAO_ACESSOS}:${SiteSection.RECERTIFICACAO_PERIODICA}`;
    this._analyticsService.doPageLoad(this.pageName);
    this.userMeInfo$ = this.store.select(selectUserMeInfo);

    this._verifyUrlToRedirect();
    this._verifyUserProfile();
  }

  public recertificate() {
    const isYesOptions = this.selectedItem === this.options[0];
    if (isYesOptions) {
      this.sendConfirmation();
    } else {
      this.sendDecline();
    }
  }

  public sendConfirmation(): void {
    this.$sub = this._recertificationService.attest().subscribe({
      complete: () => {
        this.success = true;
        this.$interval = window.setInterval(() => {
          if (!this.mode) {
            this.closeSideNav();
          }

          this.store.dispatch(UserActions.loadUserMeInfo());
          this.recerticationIsSuccess.emit(true);
        }, 3000);

        this._analyticsService.doPageLoad(`${this.pageName}:Sucesso`, {
          events: ["portalLogons_recertificacaoPeriodicaSucesso"],
        });
      },
      error: (error: HttpErrorResponse) => {
        this.hasError = true;
        this.recerticationIsSuccess.emit(false);

        this._analyticsService.sendCustomError(
          error,
          SiteSection.ERRO_RECERTIFICACAO_PERIODICA,
        );
      },
    });
  }

  public closeSideNav() {
    this.store.dispatch(closeSideNav());
  }

  public sendDecline() {
    this._recertificationService.decline().subscribe({
      complete: () => {
        this._analyticsService.doPageLoad(`${this.pageName}:Sucesso`, {
          events: ["portalLogons_recertificacaoPeriodicaGestorRevogadoSucesso"],
        });

        this.logout();
      },
      error: (error: HttpErrorResponse) => {
        this.hasError = true;

        this._analyticsService.sendCustomError(
          error,
          SiteSection.ERRO_RECERTIFICACAO_PERIODICA,
        );
      },
    });
  }

  public logout() {
    this.success = true;
    Utils.deleteCookie("accessToken");
    const a = document.createElement("a");
    a.href = `${environment.productMenuMainURL}`;
    a.click();
  }

  ngOnDestroy() {
    window.clearInterval(this.$interval);
    localStorage.removeItem("isPME");
    this.$sub?.unsubscribe();
  }

  private _verifyUrlToRedirect(): void {
    if (Utils.isClientIdOfPMEApp()) {
      this.urlToRedirect =
        "https://ajuda.pme.serasaexperian.com.br/hc/pt-br/articles/11310694296723-Altera%C3%A7%C3%A3o-dos-dados-do-contrato-pelo-respons%C3%A1vel-do-contrato";
    } else {
      this.urlToRedirect =
        "https://ajuda.serasaexperian.com.br/hc/pt-br/articles/16462227261203-Altera%C3%A7%C3%A3o-dos-dados-do-contrato-pelo-respons%C3%A1vel-do-contrato";
    }
  }

  private _verifyUserProfile(): void {
    this.userProfile = Utils.verifyUserProfile();
    this.options = [
      this.managerOpt.YES.replace("{{profile}}", this.userProfile),
      this.managerOpt.NO.replace("{{profile}}", this.userProfile),
    ];
  }
}
